export type AddressPlacement = 'beside_logo' | 'header_bottom' | 'hidden'

export interface HeaderLogoSettings {
  logo?: string
  horizontal_logo?: string
  hide_shipper_name?: boolean
  shipper_name?: string
  address_placement?: AddressPlacement
}

export interface HeaderLogoConfig {
  showBrandName: boolean
  useHorizontalLogo: boolean
  logoSrc: string | null
  shipperName: string
  isCompactLayout: boolean
  addressPlacement: AddressPlacement
}

export function resolveAssetUrl(url?: string | null): string | null {
  if (!url) return null
  return url.includes('https') ? url : `${process.env.BASE_URL || ''}${url}`
}

export function getHeaderLogoConfig(
  settings?: HeaderLogoSettings | null
): HeaderLogoConfig {
  const hideShipperName = Boolean(settings?.hide_shipper_name)
  const shipperName = settings?.shipper_name || 'Brand'
  const useHorizontalLogo =
    hideShipperName && Boolean(settings?.horizontal_logo)
  const rawSrc = useHorizontalLogo
    ? settings?.horizontal_logo
    : settings?.logo
  const logoSrc = resolveAssetUrl(rawSrc)
  const showBrandName = !hideShipperName && Boolean(settings?.shipper_name)
  const addressPlacement = settings?.address_placement ?? 'beside_logo'
  const isCompactLayout =
    hideShipperName && addressPlacement === 'beside_logo'

  return {
    showBrandName,
    useHorizontalLogo,
    logoSrc,
    shipperName,
    isCompactLayout,
    addressPlacement,
  }
}

export function getStickyHeaderOffset({
  addressPlacement = 'beside_logo',
  isCompactLayout = false,
  isHall = '',
  isInteractive = false,
}: {
  addressPlacement?: AddressPlacement
  isCompactLayout?: boolean
  isHall?: string
  isInteractive?: boolean
}): string {
  if (isInteractive) return '0'

  if (addressPlacement === 'header_bottom') {
    return isHall === 'true' ? '92px' : '125px'
  }

  if (isCompactLayout) return '100px'

  return '80px'
}
